import React from "react";
import { localize } from "@backpacker/number";
import { Locale } from "@linkfluence/models/locale";
import Tooltip from "@ui-kit/tooltip";
import { tr } from "@radarly/i18n";

const tooltipScore = (score: number, locale: Locale): string =>
  !score ? "N/A" : localize(locale, score);

interface IProps {
  metric: string;
  value?: number;
  locale: Locale;
  children: React.ReactNode;
}

export const RadarlyComponentsPostMetricsTooltip = ({
  metric,
  value,
  locale,
  children,
}: IProps) => {
  //no tooltips when value is null or < 1000
  const withTooltip = value !== null && value > 999;
  return (
    <>
      {withTooltip ? (
        <Tooltip
          tooltip={`${tr(locale, `POST::METRIC::${metric}`)}: ${tooltipScore(
            value,
            locale
          )}`}
        >
          {children}
        </Tooltip>
      ) : (
        <>{children}</>
      )}
    </>
  );
};

export default RadarlyComponentsPostMetricsTooltip;
